import PartnerResponse from "./PartnerResponsePopUp";
export default PartnerResponse